<template>
	<!-- 导出行程 -->

	<div class="box">
		<div class="botmBtnContainer">
			<el-button size="small" type="primary" @click="print();">打印本页</el-button>
			<el-button @click="exportWord" size="small" type="primary">导出word</el-button>
			<!-- <el-button size="small" type="primary">游客名单</el-button> -->
		</div>
		<div class="content" id="pagecontent">
			<table class="toptable" cellpadding="0" cellspacing="0" border="0">
				<tr>
					<td>
						<h1>
							{{companyInfo.companyName}}<br />
							<samp>
								电话：{{companyInfo.tel}}
								传真：{{companyInfo.fax}}<br />
								<span v-if="companyInfo.adress">地址：{{companyInfo.adress}}</span>
							</samp>
						</h1>
					</td>
				</tr>
			</table>
			<div>&nbsp;</div>
			<table class="midtable" cellpadding="0" cellspacing="0" border="0">
				<tr>
					<td colspan="6">
						<h2>{{detailData.productName}}</h2>
					</td>
				</tr>
				<tr>
					<th>产品编号</th>
					<td class="ninety">{{detailData.productId}}</td>
					<th>出发地</th>
					<td class="cityName">{{detailData.startCity}}</td>
					<th>旅游天数</th>
					<td class="num">{{detailData.travelDay}}</td>
				</tr>
				<tr>
					<th>出团日期</th>
					<td class="ninety">{{orderInfo && orderInfo.startDate || ""}}</td>
					<th>出发交通</th>
					<td colspan="3" class="cityName">{{detailData.goTraffic}}</td>
				</tr>
				<tr>
					<th>返程日期</th>
					<td class="ninety">{{orderInfo && orderInfo.backDay || ""}}</td>
					<th>返程交通</th>
					<td colspan="3" class="cityName">{{detailData.backTraffic}}</td>
				</tr>
				<tr>
					<th>集合时间</th>
					<td class="ninety">{{detailData.collectionTime ? detailData.collectionTime:""}}</td>
					<th>集合地点</th>
					<td class="cityName">{{detailData.collectionPlace ? detailData.collectionPlace:""}}</td>
					<th>单房差价</th>
					<td class="num">{{detailData.housePrice ? detailData.housePrice :0}}</td>
				</tr>
				<tr>
					<th>送团电话</th>
					<td class="ninety">{{detailData.giveTel ? detailData.giveTel:""}}</td>
					<th>送团标志/人</th>
					<td colspan="3" class="num">{{detailData.giveId ? detailData.giveId:""}}</td>
				</tr>
				<tr>
					<th>产品亮点</th>
					<td colspan="5" class="list"
						v-html="repalce(detailData.productDetail && detailData.productDetail.summary || '')"></td>
				</tr>
				<tr class="faq">
					<th>报名须知</th>
					<td colspan="5" class="list"
						v-html="repalce(detailData.productDetail && detailData.productDetail.signUp || '')"></td>
				</tr>
				<tr>
					<td colspan="6">
						<div class="price">
							<span>成人价格：</span>
							<b>&yen;{{detailData.adminPrice}}</b> <span>/人 </span>
							<span>小孩价格：</span>
							<b>&yen;{{detailData.childPrice}}</b> <span>/人 </span>
						</div>
					</td>
				</tr>
			</table>
			<div>&nbsp;</div>
			<table class="routeinfo" cellpadding="0" cellspacing="0" border="0">
				<tr>
					<th class="date">日期</th>
					<th>描述</th>
					<th class="food">三餐</th>
					<th class="hotel">住宿</th>
				</tr>
				<tr v-for="(item,index) in templateList" :key="index">
					<td class="date">第{{item.day}}天</td>
					<td class="descript">
						<div class="title">{{item.title}}</div>
						<div v-html="repalce(item.remark || '')"></div>
					</td>
					<td class="food">
						{{item.isBreakfast === 0 ? '':'早餐'}}
						{{item.isLunch === 0 ? '':'中餐'}}
						{{item.isDinner === 0 ? '':'晚餐'}}
					</td>
					<td class="hotel">{{item.hotelName}}</td>
				</tr>
			</table>
			<div>&nbsp;</div>
			<table class="include" cellpadding="0" cellspacing="0" border="0">
				<tr>
					<th v-if="detailData.productDetail && detailData.productDetail.inclustionItems">
						包含项目
					</th>
					<td v-if="detailData.productDetail && detailData.productDetail.inclustionItems"
						v-html="repalce(detailData.productDetail && detailData.productDetail.inclustionItems || '')">
					</td>
				</tr>
				<tr>
					<th v-if="detailData.productDetail && detailData.productDetail.noInclustionItems">
						不包含项目
					</th>
					<td v-if="detailData.productDetail && detailData.productDetail.noInclustionItems"
						v-html="repalce(detailData.productDetail && detailData.productDetail.noInclustionItems || '')">
					</td>
				</tr>
				<tr>
					<th v-if="detailData.productDetail && detailData.productDetail.childPlan">
						儿童安排
					</th>
					<td v-if="detailData.productDetail && detailData.productDetail.childPlan"
						v-html="repalce(detailData.productDetail && detailData.productDetail.childPlan || '')"></td>
				</tr>
				<tr>
					<th v-if="detailData.productDetail && detailData.productDetail.shopPlan">
						购物安排
					</th>
					<td v-if="detailData.productDetail && detailData.productDetail.shopPlan"
						v-html="repalce(detailData.productDetail && detailData.productDetail.shopPlan || '')"></td>
				</tr>
				<tr>
					<th v-if="detailData.productDetail && detailData.productDetail.mayPlan">
						可选项目
					</th>
					<td v-if="detailData.productDetail && detailData.productDetail.mayPlan"
						v-html="repalce(detailData.productDetail && detailData.productDetail.mayPlan || '')"></td>
				</tr>
				<tr>
					<th v-if="detailData.productDetail && detailData.productDetail.givePlan">
						赠送项目
					</th>
					<td v-if="detailData.productDetail && detailData.productDetail.givePlan"
						v-html="repalce(detailData.productDetail && detailData.productDetail.givePlan || '')"></td>
				</tr>
				<tr>
					<th v-if="detailData.productDetail && detailData.productDetail.attentions">
						注意事项
					</th>
					<td v-if="detailData.productDetail && detailData.productDetail.attentions"
						v-html="repalce(detailData.productDetail && detailData.productDetail.attentions || '')"></td>
				</tr>
				<tr>
					<th v-if="detailData.productDetail && detailData.productDetail.otherPlan">
						其他事项
					</th>
					<td v-if="detailData.productDetail && detailData.productDetail.otherPlan"
						v-html="repalce(detailData.productDetail && detailData.productDetail.otherPlan || '')"></td>
				</tr>
			</table>
			<div>&nbsp;</div>
			<table class="reminder" cellpadding="0" cellspacing="0" border="0">
				<tr>
					<th v-if="detailData.productDetail && detailData.productDetail.reminder">温馨提醒</th>
					<td v-if="detailData.productDetail && detailData.productDetail.reminder"
						v-html="repalce(detailData.productDetail && detailData.productDetail.reminder || '')"></td>
				</tr>
			</table>
			&nbsp;
			<table class="foot" cellpadding="0" cellspacing="0" border="0">
				<el-row>
					<el-col :span="16">操作人：{{operatorName}} &nbsp;&nbsp;打印日期：{{detailData.currentDate}}</el-col>
					<el-col :span="8">
						<el-checkbox>
							我已阅读行程细则并认可</el-checkbox>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="16">&nbsp;</el-col>
					<el-col :span="8">
						签字：
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="16">&nbsp;</el-col>
					<el-col :span="8">
						日期：
					</el-col>
				</el-row>
				<!-- <tr>
					<td colspan="3"</td>
					<td colspan="1">
						
					</td>
				</tr> -->
			</table>
		</div>
	</div>
</template>

<script>
	import * as mutils from 'utils/mUtils'
	import {
		axios
	} from 'utils/'

	export default {
		data() {
			return {
				productId: null,
				orderNo: null,
				detailData: [],
				templateList: [],
				productLight: [],
				orderInfo: null,
				operatorName: null,
				companyInfo: [],
			}
		},
		created() {
			this.productId = this.$route.query.productId || 0;
			this.orderNo = this.$route.query.orderNo || "";

			if (this.orderNo) {
				this.getOrderInfo();
			} else {
				this.getProductDetail();
			}

			this.operatorName = mutils.getUserName();
			this.getCompanyInfo();
		},
		methods: {
			print() {
				javascript: window.print();
			},
			//空格换行
			repalce(str) {
				if (!str) return "";
				return decodeURIComponent(str).replace(new RegExp(/\n/g), "<br/>");
			},
			//获取组团社信息
			getCompanyInfo() {
				var that = this;
				that.$sub.post('/v1/travel/company/getCompanyInfo', {
						userId: mutils.getUserId(),
						token: mutils.getToken(),
					})
					.then(function (res) {
						that.companyInfo = res.data.data;
					})
			},
			//获取详情数据
			getProductDetail() {
				var that = this;
				that.$sub.post('/v1/travel/product/getProductDetail', {
						userId: mutils.getUserId(),
						token: mutils.getToken(),
						productId: that.productId,
					})
					.then(function (res) {
						// console.log("res:" + JSON.stringify(res.data.data));
						let data = res.data.data;
						if (data != null) {
							data.productName = decodeURIComponent(data.productName);
							data.companyName = decodeURIComponent(data.companyName);
							var templateList = [];
							if (data.productTemplateList != null) {
								data.productTemplateList.forEach(function (item, index) {
									item.productDate = "第" + (index + 1) + "天";
									item.title = decodeURIComponent(item.title);
									item.hotelName = decodeURIComponent(item.hotelName);
									item.remark = decodeURIComponent(item.remark);

									item.can = item.isBreakfast == 1 ? "早餐" : "";
									item.can += item.isLunch == 1 ? "中餐" : "";
									item.can += item.isDinner == 1 ? "晚餐" : "";

									templateList.push(item)
								})
							}
							that.templateList = templateList;
						}
						that.detailData = data;
					})
			},
			getOrderInfo() {
				var that = this;
				// return
				that.$sub.post('/v1/travel/order/orderInfo', {
						userId: mutils.getUserId(),
						token: mutils.getToken(),
						orderNo: that.orderNo,
					})
					.then(function (res) {
						// console.log(res);
						that.orderInfo = res.data.data;
						that.productId = that.orderInfo.productId;
						that.getProductDetail();
					})
			},
			getObj(obj) {
				if (obj == "") return [];
				obj = decodeURIComponent(obj);
				var arr = obj.split('\n');
				var list = [];
				for (var i = 0; i < arr.length; i++) {
					var parameter = {};
					parameter.value = arr[i];
					list.push(parameter)
				}
				return JSON.stringify(obj);
			},
			// 点击导出word
			exportWord: function () {
				let _this = this;
				// 读取并获得模板文件的二进制内容
				JSZipUtils.getBinaryContent("/static/route.docx", function (error, content) {
					// 抛出异常
					if (error) {
						throw error;
					}

					// 创建一个JSZip实例，内容为模板的内容
					let zip = new JSZip(content);
					// 创建并加载docxtemplater实例对象
					let doc = new window.docxtemplater().loadZip(zip);

					doc.setOptions({
						linebreaks: true
					});
					// 设置模板变量的值
					doc.setData({
						companyName: _this.detailData.companyName,
						companyTel: _this.detailData.companyTel,
						companyFax: _this.detailData.companyFax,
						companyAddress: _this.detailData.companyAddress,
						productId: _this.detailData.productId,
						productName: _this.detailData.productName,
						startCity: _this.detailData.startCity,
						travelDay: _this.detailData.travelDay,
						startDate: _this.orderInfo && _this.orderInfo.startDate || "",
						backDate: _this.orderInfo && _this.orderInfo.backDay || "",
						goTraffic: _this.detailData.goTraffic,
						backTraffic: _this.detailData.backTraffic,
						collectionTime: _this.detailData.collectionTime || "",
						collectionPlace: _this.detailData.collectionPlace || "",
						giveTel: _this.detailData.giveTel || "",
						giveId: _this.detailData.giveId || "",
						adminPrice: _this.detailData.adminPrice || 0,
						childPrice: _this.detailData.childPrice || 0,
						housePrice: _this.detailData.housePrice || 0,
						summary: decodeURIComponent(_this.detailData.productDetail.summary || ""),
						signUp: decodeURIComponent(_this.detailData.productDetail.signUp || ""),
						inclustionItems: decodeURIComponent(_this.detailData.productDetail
							.inclustionItems || ""),
						noInclustionItems: decodeURIComponent(_this.detailData.productDetail
							.noInclustionItems || ""),
						childPlan: decodeURIComponent(_this.detailData.productDetail.childPlan || ""),
						shopPlan: decodeURIComponent(_this.detailData.productDetail.shopPlan || ""),
						mayPlan: decodeURIComponent(_this.detailData.productDetail.mayPlan || ""),
						givePlan: decodeURIComponent(_this.detailData.productDetail.givePlan || ""),
						attentions: decodeURIComponent(_this.detailData.productDetail.attentions ||
							""),
						otherPlan: decodeURIComponent(_this.detailData.productDetail.otherPlan || ""),
						reminder: decodeURIComponent(_this.detailData.productDetail.reminder || ""),
						operatorName: _this.operatorName,
						currentDate: _this.detailData.currentDate || "",
						tableTemplate: _this.templateList
					});

					try {
						// 用模板变量的值替换所有模板变量
						doc.render();
					} catch (error) {
						// 抛出异常
						let e = {
							message: error.message,
							name: error.name,
							stack: error.stack,
							properties: error.properties
						};
						// console.log(JSON.stringify({
						// 	error: e
						// }));
						throw error;
					}

					// 生成一个代表docxtemplater对象的zip文件（不是一个真实的文件，而是在内存中的表示）
					let out = doc.getZip().generate({
						type: "blob",
						mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
					});
					// 将目标文件对象保存为目标类型的文件，并命名
					saveAs(out, _this.detailData.productName + ".docx");
				});
			}
		}
	}
</script>

<style lang="less" scoped>
	.box {
		margin: 60px 70px;
		list-style: none;
	}

	.botmBtnContainer {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 45px;
		line-height: 45px;
		background-color: #fff;
		text-align: center;
		border-bottom: 1px solid #999;
	}

	.content {
		width: 750px;
		margin: 0 auto;
		padding: 20px 30px;
		background: #fff;
	}

	.content table {
		text-align: center;
		border-top: none;
		border-collapse: collapse;
		border-bottom: none;
		width: 750px;
		font-size: 8pt;
		border: 1px solid #000 !important;
	}

	.toptable {
		padding-bottom: 15px;
		clear: both;

		td {
			width: 100%;
			font-weight: bold;
			border: 1px solid #999;
			border-bottom: none;
			text-align: center;

			h1 {
				font-size: 16pt;

				samp {
					font-size: 11pt;
				}
			}
		}
	}

	.midtable {
		th {
			width: 90pt;
			text-align: center;
			border: 1px solid #999;
		}

		td {
			border: 1px solid #999;
			text-align: left;
		}

		.ninety {
			width: 90pt;
		}

		.cityName {
			width: 370pt;
		}

		.num {
			width: 100pt;
		}

		.list {
			width: 465pt;
			text-align: left;
		}
	}

	.price {
		line-height: 30pt;
		height: 30px;
		margin-bottom: 10px;
		text-align: center;

		span {
			font-size: 16px
		}

		b {
			color: #f69053;
			font-size: 20px;
		}
	}

	.routeinfo {
		th {
			padding: 3pt 5pt;
			font-size: 9pt;
			border: 1px solid #999;
		}

		td {
			padding: 3pt 5pt;
			font-size: 9pt;
			word-break: break-all;
			border: 1px solid #999;
		}

		.date {
			width: 40pt;
		}

		.food {
			width: 59pt;
		}

		.descript {
			width: 350pt;
			text-align: left;
		}

		.hotel {
			width: 80pt;
		}
	}

	.include {
		th {
			width: 50pt;
			border: 1px solid #999;
		}

		td {
			width: 500pt;
			border: 1px solid #999;
			text-align: left;
		}
	}

	.reminder {
		th {
			width: 65pt;
			border: 1px solid #999;
		}

		td {
			width: 685pt;
			border: 1px solid #999;
			text-align: left;
		}
	}

	.foot {
		width: 750px;
		text-align: left !important;
		border: 1px solid #fff !important;
		line-height: 30px;
		// td{
		// 	border:none; 
		// 	padding-top:8px;
		// 	text-align: left;
		// }

	}

	.content table[data-v-2dc906a6] {
		border: 1px solid #fff !important;
	}

	.content h2 {
		font-size: 11pt;
		color: #000;
	}

	.content td h2 {
		margin: 5px 0;
		font-weight: bold;
	}

	.title {
		font-weight: bold;
		color: #000;
		font-size: 14px;
		margin: 5px 0;
	}

	.content th {
		line-height: 1.4;
		border: 1px solid #999;
		padding: 3pt 5pt;
		font-size: 9pt;
		word-break: break-all;
		word-wrap: break-word;
	}

	.content td {
		line-height: 22px;
		font-size: 10pt;
		padding: 3pt 5pt;
	}
</style>


// WEBPACK FOOTER //
// route.vue?5638d537